import React from 'react';
import { Form } from '../../../toolympus/components/primitives';
import { DiscountCodesList } from './DiscountCodesList';

interface Props {
  
}

export const DiscountCodesListPage = (props: Props) => {
  return (
    <Form
        title="Discount codes"
        headerItems={<>
        </>}
        >
      <DiscountCodesList />
    </Form>
  );
}
